import { 
  login, 
  register, 
  logout, 
  verifyEmail, 
  resendVerification,
  forgotPassword,
  resetPassword,
  refresh,
  getUserInfo,
  updateProfile,
  changePassword,
  getUserStatistics,
  getUserAchievements,
  getUserDashboard
} from "./asyncThunks";

export const loginBuilder = (builder) => {
  builder.addCase(login.pending, (state) => {
    state.loginPending = true;
    state.error = null;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { user } = action.payload;
    state.loginPending = false;
    state.loggedIn = true;
    state.user = user;
    state.authChecking = false;
    state.error = null;
  });
  builder.addCase(login.rejected, (state, action) => {
    state.loginPending = false;
    state.error = action.error.message;
    state.loggedIn = false;
    state.authChecking = false;
  });
};

export const registerBuilder = (builder) => {
  builder.addCase(register.pending, (state) => {
    state.registerPending = true;
    state.error = null;
  });
  builder.addCase(register.fulfilled, (state, action) => {
    const { user } = action.payload;
    state.registerPending = false;
    state.loggedIn = true;
    state.user = user;
    state.error = null;
    state.needsEmailVerification = !user.isEmailVerified;
  });
  builder.addCase(register.rejected, (state, action) => {
    state.registerPending = false;
    state.error = action.error.message;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
    state.user = null;
  });
  builder.addCase(logout.fulfilled, (state) => {
    state.loggedIn = false;
    state.user = null;
    state.error = null;
  });
  builder.addCase(logout.rejected, (state) => {
    state.loggedIn = false;
    state.user = null;
  });
};

export const verifyEmailBuilder = (builder) => {
  builder.addCase(verifyEmail.pending, (state) => {
    state.verifyEmailPending = true;
    state.error = null;
  });
  builder.addCase(verifyEmail.fulfilled, (state) => {
    state.verifyEmailPending = false;
    state.needsEmailVerification = false;
    state.error = null;
    if (state.user) {
      state.user.isEmailVerified = true;
    }
  });
  builder.addCase(verifyEmail.rejected, (state, action) => {
    state.verifyEmailPending = false;
    state.error = action.error.message;
  });
};

export const resendVerificationBuilder = (builder) => {
  builder.addCase(resendVerification.pending, (state) => {
    state.resendPending = true;
    state.error = null;
  });
  builder.addCase(resendVerification.fulfilled, (state) => {
    state.resendPending = false;
    state.error = null;
  });
  builder.addCase(resendVerification.rejected, (state, action) => {
    state.resendPending = false;
    state.error = action.error.message;
  });
};

export const forgotPasswordBuilder = (builder) => {
  builder.addCase(forgotPassword.pending, (state) => {
    state.forgotPasswordPending = true;
    state.error = null;
  });
  builder.addCase(forgotPassword.fulfilled, (state) => {
    state.forgotPasswordPending = false;
    state.passwordResetRequested = true;
    state.error = null;
  });
  builder.addCase(forgotPassword.rejected, (state, action) => {
    state.forgotPasswordPending = false;
    state.error = action.error.message;
  });
};

export const resetPasswordBuilder = (builder) => {
  builder.addCase(resetPassword.pending, (state) => {
    state.resetPasswordPending = true;
    state.error = null;
  });
  builder.addCase(resetPassword.fulfilled, (state) => {
    state.resetPasswordPending = false;
    state.passwordResetSuccess = true;
    state.error = null;
  });
  builder.addCase(resetPassword.rejected, (state, action) => {
    state.resetPasswordPending = false;
    state.error = action.error.message;
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { user } = action.payload;
    state.loggedIn = true;
    state.user = user;
    state.error = null;
    state.authChecking = false;
  });
  builder.addCase(refresh.rejected, (state) => {
    state.loggedIn = false;
    state.user = null;
    state.authChecking = false;
  });
};

export const getUserInfoBuilder = (builder) => {
  builder.addCase(getUserInfo.pending, (state) => {
    state.userInfoPending = true;
  });
  builder.addCase(getUserInfo.fulfilled, (state, action) => {
    const { user } = action.payload;
    state.userInfoPending = false;
    state.loggedIn = true;
    state.user = user;
    state.error = null;
  });
  builder.addCase(getUserInfo.rejected, (state) => {
    state.userInfoPending = false;
    state.loggedIn = false;
    state.user = null;
  });
};

export const updateProfileBuilder = (builder) => {
  builder.addCase(updateProfile.pending, (state) => {
    state.userInfoPending = true;
    state.error = null;
  });
  builder.addCase(updateProfile.fulfilled, (state, action) => {
    const { user } = action.payload;
    state.userInfoPending = false;
    state.user = user;
    state.error = null;
  });
  builder.addCase(updateProfile.rejected, (state, action) => {
    state.userInfoPending = false;
    state.error = action.error.message;
  });
};

export const changePasswordBuilder = (builder) => {
  builder.addCase(changePassword.pending, (state) => {
    state.changePasswordPending = true;
    state.error = null;
  });
  builder.addCase(changePassword.fulfilled, (state) => {
    state.changePasswordPending = false;
    state.error = null;
  });
  builder.addCase(changePassword.rejected, (state, action) => {
    state.changePasswordPending = false;
    state.error = action.error.message;
  });
};

export const getUserStatisticsBuilder = (builder) => {
  builder.addCase(getUserStatistics.pending, (state) => {
    state.statisticsPending = true;
    state.error = null;
  });
  builder.addCase(getUserStatistics.fulfilled, (state, action) => {
    const { statistics } = action.payload;
    state.statisticsPending = false;
    state.statistics = statistics;
    state.error = null;
  });
  builder.addCase(getUserStatistics.rejected, (state, action) => {
    state.statisticsPending = false;
    state.error = action.error.message;
  });
};

export const getUserAchievementsBuilder = (builder) => {
  builder.addCase(getUserAchievements.pending, (state) => {
    state.achievementsPending = true;
    state.error = null;
  });
  builder.addCase(getUserAchievements.fulfilled, (state, action) => {
    const { achievements } = action.payload;
    state.achievementsPending = false;
    state.achievements = achievements;
    state.error = null;
  });
  builder.addCase(getUserAchievements.rejected, (state, action) => {
    state.achievementsPending = false;
    state.error = action.error.message;
  });
};

export const getUserDashboardBuilder = (builder) => {
  builder.addCase(getUserDashboard.pending, (state) => {
    state.dashboardPending = true;
    state.error = null;
  });
  builder.addCase(getUserDashboard.fulfilled, (state, action) => {
    const { dashboard } = action.payload;
    state.dashboardPending = false;
    state.dashboard = dashboard;
    state.error = null;
  });
  builder.addCase(getUserDashboard.rejected, (state, action) => {
    state.dashboardPending = false;
    state.error = action.error.message;
  });
};
